export default __webpack_public_path__ + "static/media/hero-alt.59dddfe5.jpg";